<template>
  <v-carousel
    class="header-carousel"
    hide-delimiters
    hide-delimiter-background
    height="auto"
    :hide-controls="slides.length <= 1"
    interval="15000"
    :cycle="true"
  >
    <v-carousel-item v-for="(slide, idx) in slides" :key="`slide-${idx}`">
      <v-layout row wrap>
        <v-flex
          v-for="item in slide"
          :key="item.key"
          v-show="!loading"
          xs6
          sm4
          md3
          lg2
          xl2
        >
          <Card class="br-4 single-card">
            <v-flex class="text-xs-center" pa-2>
              <div v-if="item.showWs" class="extraGrey--text">
                <div class="ws-name">
                  <v-tooltip top content-class="custom-tooltip">
                    <template v-slot:activator="{ on }">
                      <span v-on="on">
                        {{ item.truncatedWsName }}
                      </span>
                    </template>
                    <span>{{ item.wsName }}</span>
                  </v-tooltip>
                </div>
              </div>
              <div class="extraGrey--text">
                <div class="font-weight-medium">
                  {{ $t(item.nameMain) }}
                </div>
              </div>
              <div class="ag-card-number font-weight-bold custom-headline">
                <span
                  :class="item.value == null ? 'error--text' : 'number--text'"
                  class="mr-1"
                  >{{ item.value == null ? $t("No Data") : item.value }}</span
                >
                <span
                  v-if="item.value != 'No Data'"
                  class="caption extraGrey--text unit"
                  >{{ item.unit }}</span
                >
              </div>
            </v-flex>
          </Card>
        </v-flex>
        <v-flex v-show="loading" xs12>
          <Card class="br-4 single-card">
            <v-flex class="text-xs-center" pa-2>
              <div class="ag-card-number font-weight-bold headline">
                {{ $t("Loading") }} ...
              </div>
            </v-flex>
          </Card>
        </v-flex>
      </v-layout>
    </v-carousel-item>
  </v-carousel>
</template>

<script>
import { mapGetters } from "vuex";
import Inverter from "@/services/Inverter";
import { mixin, mapGettersMixin, miscellaneous } from "@/util/mixin/index";
const momentTz = require("moment-timezone");

export default {
  mixins: [mixin, mapGettersMixin, miscellaneous],
  props: {
    date: {
      type: Object,
    },
  },
  data() {
    return {
      selectedPlant: "",
      start_date: "",
      end_date: "",
      items: [],
      loading: true,
      enableWatch: false,
    };
  },
  async mounted() {
    const tz = this.getActivePlantTimezone;
    if (!(this.date && this.date.from)) {
      this.start_date = momentTz().tz(tz).format("YYYY-MM-DD");
    } else {
      this.start_date = this.date.from;
    }

    if (!(this.date && this.date.to)) {
      this.end_date = momentTz().tz(tz).format("YYYY-MM-DD");
    } else {
      this.end_date = this.date.to;
    }
    this.selectedPlant = this.getSelectedPlantId;
    await this.setIntervalWithoutDelay(this.getGenerationData);
  },
  computed: {
    ...mapGetters(["getSelectedPlantId", "getActivePlantTimezone"]),
    slides() {
      if (!Array.isArray(this.items)) return [];
      const chunkSize = 12;
      const chunks = [];
      for (let i = 0; i < this.items.length; i += chunkSize) {
        chunks.push(this.items.slice(i, i + chunkSize));
      }
      return chunks;
    },
  },
  methods: {
    async getGenerationData() {
      this.loading = true;
      this.enableWatch = true;
      try {
        const param = this.getHeaderParam();
        let response = await Inverter.fetchHeader(param);
        const normalized = (response.data.message || []).map((it, idx) => {
          const nameStr = it.name || "";
          const m = String(nameStr).match(/^(.*?)(?:\s*\((.+)\)\s*)$/);
          const nameMain = m ? m[1].trim() : nameStr;
          const wsName = m ? m[2].trim() : null;
          function truncate(str, length = 5) {
            return str.length > length ? str.slice(0, length) + "..." : str;
          }
          return {
            ...it,
            key: it.key || `${nameMain.replace(/\s+/g, "_")}_${idx}`,
            nameMain,
            wsName,
            truncatedWsName: truncate(wsName || "", 20),
          };
        });

        this.items = normalized.map((it) => ({
          ...it,
          showWs: Boolean(it.wsName),
        }));
        this.loading = false;
      } catch (err) {
        this.items = [];
        this.loading = false;
      }
    },
    getHeaderParam() {
      return {
        plantId: this.selectedPlant,
        dateFrom: this.start_date,
        dateTo: this.end_date,
      };
    },
  },
  watch: {
    getSelectedPlantId(val) {
      this.selectedPlant = val;
      this.getGenerationData();
    },
    date(val, oldVal) {
      if (this.enableWatch && !this.isObjectEqual(oldVal, val)) {
        this.start_date = this.date.from;
        this.end_date = this.date.to;
        this.getGenerationData();
      }
    },
  },
};
</script>

<style scoped>
.single-card {
  height: 100%;
  display: flex;
  align-items: center;
}

.custom-headline {
  font-size: 24px;
  line-height: 24px;
}

.ws-name {
  font-size: 12px;
  color: rgba(158, 158, 158, 0.95);
}

.custom-tooltip {
  background-color: var(--v-primary-base) !important;
  color: var(--v-extraGrey-base);
  border-radius: 4px;
  border: 1px solid rgba(83, 122, 228, 0.418);
  z-index: 10 !important;
}

@media only screen and (min-width: 320px) and (max-width: 600px) {
  .ag-card-number {
    font-size: 20px !important;
    text-overflow: ellipsis;
  }
}
</style>
